import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/events" element={<EventsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

// Simple Events page placeholder
const EventsPage = () => {
  return (
    <div className="EventsPage">
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ color: 'var(--primary-700)' }}>Events & Workshops</h1>
            <p style={{ fontSize: 'var(--text-lg)', maxWidth: '600px', margin: '0 auto var(--space-lg)' }}>
              Join us for seasonal workshops, gardening tips, and special events throughout the year.
            </p>
            <div className="card" style={{ 
              textAlign: 'center',
              background: 'var(--primary-100)',
              border: '2px solid var(--primary-500)',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              <p style={{ marginBottom: 'var(--space-md)' }}>
                We're currently planning our 2025 events schedule. Check back soon for workshops on:
              </p>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                textAlign: 'left',
                marginBottom: 'var(--space-lg)'
              }}>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 'var(--space-sm)',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '16px', 
                    height: '16px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Spring planting workshops
                </li>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 'var(--space-sm)',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '16px', 
                    height: '16px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Hardscaping techniques
                </li>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '16px', 
                    height: '16px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Seasonal maintenance tips
                </li>
              </ul>
              <p style={{ color: 'var(--neutral-400)' }}>
                Contact us at <a href="mailto:tammy@snowknows.com" style={{ color: 'var(--primary-500)' }}>tammy@snowknows.com</a> for more information.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default App;